const updateCrossSellControls = (slider) => {
  if (!slider.isConnected || slider.clientWidth === 0) return;

  const crossSell = slider.closest('.cart-cross-sell');
  const previous = crossSell.querySelector('.cross-sell-control--prev');
  const next = crossSell.querySelector('.cross-sell-control--next');
  const atStart = slider.scrollLeft <= 1;
  const atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;

  previous.classList.toggle('is-inactive', atStart);
  previous.disabled = atStart;
  next.classList.toggle('is-inactive', atEnd);
  next.disabled = atEnd;
};

const scheduleCrossSellControlUpdate = (slider) => {
  requestAnimationFrame(() => updateCrossSellControls(slider));
};

const crossSellResizeObserver = new ResizeObserver((entries) => {
  entries.forEach(({ target }) => updateCrossSellControls(target));
});

const observeCrossSellSliders = (root) => {
  if (root.matches?.('.cart-cross-sell .cross-sell-slider')) {
    crossSellResizeObserver.observe(root);
    scheduleCrossSellControlUpdate(root);
  }

  root.querySelectorAll?.('.cart-cross-sell .cross-sell-slider').forEach((slider) => {
    crossSellResizeObserver.observe(slider);
    scheduleCrossSellControlUpdate(slider);
  });
};

observeCrossSellSliders(document);

document.addEventListener('scroll', (event) => {
  if (event.target.matches?.('.cart-cross-sell .cross-sell-slider')) {
    updateCrossSellControls(event.target);
  }
}, true);

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      observeCrossSellSliders(node);
    });
  });
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', (event) => {
  const control = event.target.closest('.cart-cross-sell .cross-sell-control');
  if (!control) return;

  const slider = control.closest('.cart-cross-sell').querySelector('.cross-sell-slider');
  const card = slider.querySelector('.cross-sell-card');
  if (!card) return;

  const gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
  const direction = control.classList.contains('cross-sell-control--next') ? 1 : -1;
  slider.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
});